import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Popup } from 'semantic-ui-react'

const HelpdeskCard = ({ image, onClick, label, className, isDisabled, description }) =>
  isDisabled ? (
    <HelpdeskCardDisabled
      image={image}
      label={label}
      className={className}
      description={description}
    />
  ) : (
    <HelpdeskCardEnabled
      image={image}
      onClick={onClick}
      label={label}
      className={className}
      description={description}
    />
  )

HelpdeskCard.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  description: PropTypes.string,
}

const HelpdeskCardEnabled = ({ image, onClick, label, className }) => (
  <div className={`ui card link ${className}`} onClick={onClick}>
    <div className="image" style={{ background: '#fff' }}>
      <img
        className="ui centered image"
        src={image}
        alt={`${label} Logo`}
        style={{ width: '6.25rem', marginTop: '1.25rem', marginBottom: '1.25rem' }}
      />
    </div>
    <div className="content" style={{ padding: '0.5rem 1rem' }}>
      <div className="description">{label}</div>
    </div>
  </div>
)

HelpdeskCardEnabled.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

const HelpdeskCardDisabled = ({ image, label, className }) => (
  <Popup
    basic
    inverted
    size="tiny"
    position="top center"
    trigger={
      <div className={`ui card ${className}`}>
        <div className="image" style={{ background: '#fff' }}>
          <img
            className="ui centered image"
            src={image}
            alt={`${label} Logo`}
            style={{ width: '6.25rem', marginTop: '1.25rem', marginBottom: '1.25rem' }}
          />
        </div>
        <div className="content" style={{ padding: '0.5rem 1rem' }}>
          <div className="description">{label}</div>
        </div>
      </div>
    }
  >
    <Popup.Content>{`You can only have one ${label} survey per account.`}</Popup.Content>
  </Popup>
)

HelpdeskCardDisabled.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

const StyledHelpdeskCard = styled(HelpdeskCard)`
  opacity: ${(props) => (props.isDisabled ? '0.45 !important' : null)};
  cursor: ${(props) => (props.isDisabled ? 'default !important' : 'pointer')};
  box-shadow: ${(props) =>
    props.selectedSurvey === props.type ? '0px 0px 0px 4px #4EC677 !important' : null};
`

export default StyledHelpdeskCard



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/ChooseHelpdeskModal/HelpdeskCard.js